import { GET_BALANCE_REQUEST, GET_BALANCE_SUCCESS, GET_BALANCE_FAILUER } from "./types"

const initialState = {
    // loading: false,
    // error: null,
    getbalancelist: []
}
const getbalanceresucer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BALANCE_REQUEST:
            return {
                ...state,
                // loading: true,
                // error: null,
            }
        case GET_BALANCE_SUCCESS: {

            return {
                ...state,
                // loading: false,
                getbalancelist: action.payload
            }
        }
        case GET_BALANCE_FAILUER:
            return {
                ...state,
                // loading: false,
                // error: action.payload.message,
            }

        default:
            return state
    }
}

export default getbalanceresucer